/**
 * 平台错误码枚举.
 * Copied from https://code.fineres.com/projects/FX/repos/fxp-corp-core/browse/src/errors/error.messages.ts?at=dev
 */
enum RawECode {
    /**
     * 系统相关错误.
     */
    UNKNOWN = -1,
    NOT_IMPLEMENTED = -2,
    NOT_SUPPORTED = -3,
    UNSAFE = -4,
    UNSTABLE = -5,
    RETRY = -6, // 201
    IPV4_WHITELIST_INVALID = 16,
    AUTHENTICATION_FAILED = 17,
    AUTHORIZATION_FAILED = 18,
    TEMPLATE_DATA_IS_REQUIRED = 19,
    VALUE_IS_REQUIRED = 20,
    VALUE_NOT_VALID = 21,
    LOCK_ACQUIRE_FAILED = 22,
    LOCK_RELEASE_FAILED = 23,
    TREE_HAS_CYCLE = 24,
    RESOURCE_PROVIDER_REQUIRED = 25,
    TASK_QUEUE_CONCURRENCY_MAX_EXCEEDED = 26,
    PERMISSION_DENIED = 27,
    EXCEED_FREQUENCY_LIMIT = 28,
    AUTHENTICATION_FAILED_SESS_INVALID = 29,
    AUTHENTICATION_FAILED_CROSS_CORP = 30,

    LICENSE_PLAN_OPTION_INVALID = 31,

    AUTHENTICATION_NO_TENANT = 32,

    /**
     * 组件相关错误.
     */
    MONGODB_DISCONNECTED = 100,
    MONGODB_UNINITIALIZED = 101,

    REDIS_DISCONNECTED = 200,
    REDIS_UNINITIALIZED = 201,

    CACHE_DISCONNECTED = 300,
    CACHE_UNINITIALIZED = 301,

    RABBIT_MQ_DISCONNECTED = 400,
    RABBIT_MQ_UNINITIALIZED = 401,

    HTTP_BAD_REQUEST = 500,
    HTTP_ENDPOINT_NOT_FOUND = 501,
    HTTP_INTERNAL_SERVER_ERR = 502,

    RPC_FAILED = 600,
    RPC_AUTHENTICATION_FAILED = 601,
    RPC_TOO_MANY_REQUESTS = 602,
    RPC_AUTHENTICATION_UNINITIALIZED = 603,

    SEMAPHORE_RELEASE_FAILED = 604,
    SEMAPHORE_TYPE_INVALID = 605,

    REQUEST_PARAMETERS_INVALID = 606,
    REQUEST_IS_INVALID = 607,
    REQUEST_IS_DUPLICATE = 608, // 4055

    /**
     * 租户相关错误.
     */
    TENANT_NOT_FOUND = 700,
    TENANT_FORBIDDEN = 701,
    TENANT_TOO_MANY_REQUESTS = 702,
    TENANT_MODULE_DISABLED = 703,
    TENANT_MODULE_PAYMENT_REQUIRED = 704,
    TENANT_IS_NOT_ACTIVATE = 705,
    TENANT_IS_CANCELED = 706,
    TENANT_IS_CANCELING = 707,
    TENANT_IS_BAN = 708,
    TENANT_IS_FROZEN = 709,
    TENANT_FEATURE_REQUIRES_AUTH_APPROVAL = 710,
    TENANT_MODULE_ENABLE_NOT_ALLOWED = 711,
    TENANT_MODULE_DISABLE_NOT_ALLOWED = 712,

    /**
     * 用户相关错误.
     */
    USER_NOT_FOUND = 1000,
    USER_ID_REQUIRED = 1001,
    USER_ID_INVALID = 1002,
    USER_USERNAME_REQUIRED = 1003, // 41034
    USER_NICKNAME_REQUIRED = 1004,
    USER_IS_NOT_OWNER = 1005,
    USER_IS_OWNER = 1006,
    USER_OAUTH_ID_REQUIRED = 1007,
    USER_OAUTH_ID_INVALID = 1008,
    USER_OAUTH_NOT_FOUND = 1009,
    USER_IS_IN_SYNC = 1010,
    USER_IS_NOT_IN_SYNC = 1011,
    USER_PHONE_REQUIRED = 1012,
    USER_REGISTER_HAS_LIMITED = 1014,
    USER_IS_NOT_ACTIVATE = 1015,
    USER_IS_CANCELED = 1016,
    USER_IS_CANCELING = 1017,
    USER_IS_BAN = 1018,
    USER_IS_FROZEN = 1019,
    USER_UNIQUE_FIELDS_DUPLICATE = 1020,
    USER_USERNAME_LENGTH_EXCEEDED = 1021,
    USER_MOBILE_NUMBER_FORMAT_INVALID = 1022,
    USER_MOBILE_NUMBER_DUPLICATE = 1023,
    USER_EMAIL_FORMAT_INVALID = 1024,
    USER_EMAIL_FORMAT_DUPLICATE = 1025,
    USER_PHONE_FORMAT_INVALID = 1026,
    USER_USERNAME_HAS_BEEN_REGISTERED = 1028,
    USER_EMAIL_HAS_BEEN_REGISTERED = 1029,
    USER_PASSWORD_FORMAT_INVALID = 1030,
    USER_PASSWORD_HISTORY_DUPLICATE = 1031,
    USER_LOGIN_FAILED_EXCEEDED = 1032,
    USER_NOT_FOUND_OR_PASSWORD_FAILED = 1033,
    USER_TOKEN_ISSUE_FAILED = 1034,
    USER_PERMISSION_DENIED = 1035,
    USER_SET_PASSWORD_BIND_EMAIL_OR_EMAIL_REQUIRED = 1036,
    USER_UNLINK_WITH_ONE_LOGIN_METHOD_DENIED = 1037,
    USER_BIND_EMAIL_DUPLICATE = 1038,
    USER_DISABLE_TWO_FACTOR_VERIFICATION_BEFORE_UNLINKING_MOBILE_DENIED = 1039,
    USER_BIND_PHONE_DUPLICATE = 1040,
    USER_EMAIL_IS_INCORRECT = 1041,
    USER_EMAIL_AUTH_CODE_INVALID = 1042,
    USER_PHONE_AUTH_CODE_INVALID = 1043,
    USER_TWO_FACTOR_VERIFICATION_DENIED = 1044,
    USER_PASSWORD_EXPIRED_RESET_REQUIRED = 1045,
    USER_PASSWORD_INVALID = 1046,
    USER_BY_SYNC_FEATURE_ACCESS_DENIED = 1047,
    USER_LOGIN_PASSWORD_MOBILE_LINK_SET_REQUIRED = 1048,
    USER_PASSWORD_SET_REQUIRED = 1049,
    USER_MOBILE_LINKED_REQUIRED = 1050,
    USER_VERIFICATION_CODE_FAILED_ATTEMPTS_EXCEEDED = 1051,
    USER_VERIFICATION_CODE_INVALID = 1052,
    USER_MOBILE_OR_EMAIL_INVALID = 1053,
    USER_VERIFICATION_PARAMETER_NOT_FOUND = 1054,
    USER_SINGLE_DEVICE_LOGIN_COOKIE_EXPIRED = 1055,
    USER_ALREADY_LOGGED_IN_ELSEWHERE = 1056,
    USER_REFRESH_TOKEN_INVALID = 1057,
    USER_PASSWORD_ABOUT_EXPIRE = 1058,
    USER_CANCEL_TOKEN_EXPIRED = 1059,
    USER_CANCEL_NOT_IN_BUF_PERIOD = 1060,
    USER_LOGIN_METHOD_LACK = 1061,
    USER_LOCALE_UNSUPPORTED = 1062,
    USER_LOGIN_CHANNEL_AT_LEAST_ONE = 1063,
    USER_REGISTER_FAILED = 1064,
    USER_IS_TENANT_MEMBER = 1065,
    USER_ACCESS_TOKEN_INVALID = 1066, // 41055
    USER_CANCEL_CONDITION_NOT_MET = 1067, // 41003
    USER_MFA_REQUIRED = 1068, // 41013
    USER_PHONE_UNBIND_BEFORE_MFA = 1069, // 41029
    USER_NO_AUTH_CODE_CAPTCHA = 1070,
    USER_WRONG_AUTH_CODE_CAPTCHA = 1071,
    USER_PHONE_INVALID = 1072,
    USER_MOBILE_INVALID = 1073,
    USER_APP_TMP_SESSION_INVALID = 1074, // 41060
    USER_INFORMATION_INVALID = 1075, // 1006
    USER_TOKEN_VERIFY_FAILED = 1076, // 13002
    USER_ACTIVATE_CODE_INVALID = 1077, // 1016
    USER_USERNAME_EMAIL_AT_LEAST_ONE = 1078, // 1023
    USER_OAUTH_BIND_ANOTHER_USER = 1079, // 1041
    USER_PHONE_BIND_ANOTHER_USER = 1080, // 1099
    USER_EMAIL_BIND_ANOTHER_USER = 1081, // 1100
    USER_BIND_EMAIL_REQUIRED = 1083, // 41061
    USER_CANNOT_TRY_PREMIUM_FEATURES = 1084, // 1042
    USER_HAS_JOINED_ANOTHER_TENANT = 1085, // 41041
    USER_USERNAME_INVALID = 1086, // 41036
    USER_LOGIN_QRCODE_INVALID_STATE = 1087, // 41059
    USER_OAUTH_ACCESS_TOKEN_OBTAIN_FAILED = 1088, // 1034
    USER_VERIFY_TOKEN_EXPIRED = 1089, // 1086
    USER_VERIFY_LINK_EXPIRED = 1090, // 1091
    USER_VERIFY_CODE_SEND_LIMIT_EXCEEDED = 1091, // 1028
    USER_EMAIL_DOMAIN_BLOCKED = 1110,
    SA_USER_PASSWORD_NOT_SET = 1094, // 36006
    // 会话锚定断言锚定时, 平台规范域已登录为另一用户, 需用户确认后再切换
    USER_LOGIN_ANCHOR_SESSION_CONFLICT = 1095,

    /**
     * 企业/租户相关错误.
     */
    CORP_NOT_FOUND = 2000,
    CORP_ID_REQUIRED = 2001,
    CORP_ID_INVALID = 2002,
    CORP_ID_MISMATCH = 2003,
    OWNER_NOT_FOUND = 2004,
    OWNER_ID_REQUIRED = 2005,
    OWNER_ID_INVALID = 2006,
    OWNER_ID_MISMATCH = 2007,
    CORP_NAME_REQUIRED = 2008,
    TMP_OWNER_ID_INVALID = 2009,
    CORP_DUPLICATE = 2010,
    TENANT_ID_REQUIRED = 2011,
    TENANT_ID_INVALID = 2012,
    TENANT_AUTH_INVALID = 2013,
    CORP_SYNC_MODE_INVALID = 2014,
    INTEGRATE_ID_INVALID = 2015,
    TENANT_IS_SYNCING = 2016,
    TENANT_NAME_TOO_LONG = 2017,
    CORP_INVITE_MEMBERS_LIMIT_EXCEEDED = 2018,
    CORP_INVITE_MEMBERS_SMS_OR_EMAIL_DAY_LIMIT_EXCEEDED = 2019,
    CORP_INVITE_MEMBERS_EMAIL_DAY_LIMIT_EXCEEDED = 2020,
    CORP_INVITE_MEMBERS_SMS_DAY_LIMIT_EXCEEDED = 2021,
    CORP_INVITE_MEMBERS_SMS_AND_EMAIL_TOTAL_LIMIT_EXCEEDED = 2022,
    CORP_INVITE_MEMBERS_SMS_OR_EMAIL_TOTAL_LIMIT_EXCEEDED = 2023,
    CORP_INVITE_MEMBERS_EMAIL_TOTAL_LIMIT_EXCEEDED = 2024,
    CORP_INVITE_MEMBERS_SMS_TOTAL_LIMIT_EXCEEDED = 2025,
    CORP_COOP_NO_COMPANY_TO_IMPORT = 2026,
    TENANT_NOT_INTEGRATE_MODE = 2027,
    TENANT_SIZE_EXCEED = 2028,
    TENANT_CREATED_FAILED = 2029,
    OWNER_EXIT_CORP_UNSUPPORTED = 2030,
    CORP_INVITE_DEPARTMENT_LINK_UNAVAILABLE = 2031,
    CORP_URL_INVALID = 2032, // fx-code: 1004
    CUSTOM_LOGIN_UNSUPPORTED = 2033, // fx-code: 7139
    CORP_CONFIG_INVALID = 2034, // fx-code: 11001
    LOGIN_CHANNEL_LACKED = 2035, // fx-code: 11002
    LOGIN_CHANNEL_UNSUPPORTED = 2036, // fx-code: 11003
    CUSTOM_CORP_THEME_UNSUPPORTED = 2037, // fx-code: 7147
    CORP_NAME_INVALID = 2038,
    SSO_CONFIG_UNSUPPORTED = 2039,
    TENANT_NOT_DEFAULT_MODE = 2040,
    TENANT_VERIFY_INFO_TYPE_MISMATCH = 2041, // fx-code: 8105
    CORP_MEMBER_NOT_EXISTS = 2042, // 1098
    MEMBER_API_UNSUPPORTED = 2043, // fx-code: 17120
    TENANT_VERIFY_LINK_EXPIRED = 2044, // 1066
    TENANT_VERIFY_REAL_NAME_AUTHENTICATION_FAILED = 2045, // 1081
    TENANT_VERIFY_REQUEST_INVALID = 2046, // 8103
    TENANT_VERIFY_NOT_EXIST = 2047, // 8106
    TENANT_VERIFY_REQUEST_ALLOW_ADMIN_ONLY = 2048, // 8107
    TENANT_AUTO_VERIFY_ATTEMPT_EXCEEDED = 2049, // 8112
    TENANT_VERIFY_COPY_CORP_ONLY = 2050, // 8113
    TENANT_VERIFY_ALREADY_EXISTS = 2051, // 8114
    TENANT_VERIFY_CERTIFICATE_ID_REQUIRED = 2052, // 8118
    TENANT_VERIFY_ID_NUMBER_INVALID = 2053, // 8119
    TENANT_VERIFY_ID_NUMBER_UNDERAGE = 2054, // 8120
    TENANT_VERIFY_BLOCKED_CERTIFICATE_USED = 2055, // 8121
    TENANT_VERIFY_CERTIFICATE_USED = 2056, // 8122
    TENANT_OWNER_TRANSFER_NOT_OWNER = 2057, // 操作者不是企业当前创建者
    TENANT_OWNER_TRANSFER_INTEGRATED_TENANT = 2058, // 集成模式企业不支持转让创建者
    TENANT_OWNER_TRANSFER_TEMPLATE_TENANT = 2059, // 模板企业不支持转让创建者
    TENANT_OWNER_TRANSFER_TO_SELF = 2060, // 不能转让给本人
    TENANT_OWNER_TRANSFER_MEMBER_NOT_ACTIVE = 2061, // 接收者不是本企业在职内部成员
    TENANT_OWNER_TRANSFER_NO_CONTACT = 2062, // 接收者未绑定手机和邮箱
    TENANT_OWNER_TRANSFER_RECEIVER_OWNS_TENANT = 2063, // 接收者名下已有企业
    TENANT_OWNER_TRANSFER_BLOCKED_BY_SUITE = 2064, // 子产品存在阻断项
    TENANT_OWNER_TRANSFER_SUITE_CHECK_UNAVAILABLE = 2065, // 子产品暂不可用
    CORP_INVITE_DEPARTMENT_LINK_EXPIRED = 2066, // 部门邀请链接已过期

    /**
     * 管理组相关错误.
     */
    MANAGE_GROUP_NOT_FOUND = 3000,
    MANAGE_GROUP_BASE_NO_INVALID = 3001,
    MANAGE_GROUP_BASE_NO_TOO_SMALL = 3002,
    MANAGE_GROUP_ID_INVALID = 3003,
    MANAGE_GROUP_NAME_REQUIRED = 3004,
    MANAGE_GROUP_DISABLED = 3005,
    MANAGE_GROUP_PERMISSION_DENIED = 3006,
    MANAGE_GROUP_MEMBERS_COUNT_EXCEEDED = 3007,
    MANAGE_GROUP_NAME_INVALID = 3008,
    MANAGE_GROUP_COUNT_EXCEEDED = 3009,
    MANAGE_GROUP_REMOVE_SELF = 3010,
    MANAGE_GROUP_COUNT_PER_MEMBER_EXCEEDED = 3011,
    MANAGE_GROUP_ADD_OWNER = 3012,
    MANAGE_GROUP_SUITE_ID_INVALID = 3013,
    MANAGE_GROUP_SYSTEM_ADMIN_COUNT_LIMIT_EXCEEDED = 3014,
    MANAGE_GROUP_MEMBER_PERMISSION_DENIED = 3015,
    OPEN_PLATFORM_MANAGER_COUNT_LIMIT_EXCEEDED = 3016,

    /**
     * 部门及部门标签相关错误.
     */
    DEPT_NOT_FOUND = 4000, // 6002
    DEPT_LABEL_NOT_FOUND = 4001,
    DEPT_BASE_NO_INVALID = 4002,
    DEPT_BASE_NO_TOO_SMALL = 4003,
    DEPT_ID_INVALID = 4004,
    DEPT_NO_INVALID = 4005,
    DEPT_PARENT_NO_INVALID = 4006,
    DEPT_PATH_NO_LIST_INVALID = 4007,
    DEPT_STATUS_INVALID = 4008,
    DEPT_TYPE_INVALID = 4009,
    DEPT_NAME_REQUIRED = 4010,
    DEPT_GUEST_CORP_ID_REQUIRED = 4011,
    DEPT_LABEL_ID_INVALID = 4012,
    DEPT_LABEL_NO_INVALID = 4013,
    DEPT_LABEL_NAME_REQUIRED = 4014,
    DEPT_IS_NOT_INTERNAL = 4015,
    DEPT_IS_NOT_GUEST_CORP = 4016,
    DEPT_IS_NOT_ACTIVE = 4017,
    DEPT_ID_DUPLICATED = 4018,
    DEPT_NO_DUPLICATED = 4019,
    DEPT_INTEGRATE_ID_DUPLICATED = 4020,
    DEPT_LABEL_ID_DUPLICATED = 4021,
    DEPT_LABEL_NO_DUPLICATED = 4022,
    DEPT_INVITE_PERIOD_INVALID = 4023,
    DEPT_PATH_TOO_LONG = 4024,
    DEPT_CREATE_FAILED = 4025,
    DEPT_NAME_DUPLICATED = 4026,
    DEPT_PARENT_NOT_FOUND = 4027,
    DEPT_HAS_CHILDREN_DEPT = 4028,
    DEPT_HAS_MEMBER = 4029,
    DEPT_NAME_INVALID = 4030,
    DEPT_OUT_OF_MANAGEMENT = 4031,
    DEPT_INTEGRATE_ID_INVALID = 4032,
    DEPT_LABEL_NAME_INVALID = 4033,
    DEPT_LABEL_NAME_DUPLICATED = 4034,
    DEPT_LABEL_COUNT_EXCEEDED = 4035,
    DEPT_MANAGER_ID_INVALID = 4036, // 6008
    /**
     * 角色及角色组相关错误.
     */
    ROLE_NOT_FOUND = 5000,
    ROLE_GROUP_NOT_FOUND = 5001,
    ROLE_OR_GROUP_BASE_NO_INVALID = 5002,
    ROLE_OR_GROUP_BASE_NO_TOO_SMALL = 5003,
    ROLE_ID_INVALID = 5004,
    ROLE_TYPE_INVALID = 5005,
    ROLE_NAME_REQUIRED = 5006,
    ROLE_GROUP_NAME_REQUIRED = 5007,
    ROLE_GROUP_ID_INVALID = 5008,
    ROLE_GROUP_TYPE_INVALID = 5009,
    ROLE_ID_DUPLICATED = 5010,
    ROLE_NO_DUPLICATED = 5011,
    ROLE_GROUP_NO_DUPLICATED = 5012,
    ROLE_INTEGRATE_ID_DUPLICATED = 5013,
    ROLE_GROUP_INTEGRATE_ID_DUPLICATED = 5014,
    ROLE_NAME_INVALID = 5015,
    ROLE_GROUP_NAME_INVALID = 5016,
    ROLE_GROUP_WITH_MEMBER_CANT_DELETE = 5017,
    ROLE_GROUP_NAME_DUPLICATED = 5018,
    ROLE_GROUP_SOURCE_IS_NOT_INTERNAL = 5019,
    ROLE_SOURCE_IS_NOT_INTERNAL = 5020,
    ROLE_NAME_DUPLICATE = 5021,
    ROLE_OUT_OF_MANAGEMENT = 5022,
    ROLE_SCOPE_INVALID = 5023,
    CORP_COOP_ROLE_SIZE_EXCEEDED = 5024,
    CORP_COOP_ROLE_NAME_DUPLICATED = 5025,
    SYNCED_ROLE_OPERATION_FORBIDDEN = 5026, // 1202

    /**
     * 成员相关错误.
     */
    MEMBER_NOT_FOUND = 6000,
    MEMBER_ID_REQUIRED = 6001,
    MEMBER_ID_INVALID = 6002,
    MEMBER_USER_ID_REQUIRED_WHEN_ACTIVE = 6003,
    MEMBER_USERNAME_REQUIRED = 6004,
    MEMBER_USERNAME_INVALID = 6005,
    MEMBER_STATUS_INVALID = 6006,
    MEMBER_FROZEN_INVALID = 6007,
    MEMBER_NICKNAME_REQUIRED = 6008,
    MEMBER_TYPE_INVALID = 6009,
    MEMBER_IS_NOT_INTERNAL = 6010,
    MEMBER_IS_NOT_GUEST_DOCKER = 6011,
    MEMBER_GUEST_CORP_ID_REQUIRED = 6012,
    MEMBER_GUEST_MEMBER_ID_REQUIRED = 6013,
    MEMBER_GUEST_MEMBER_ID_INVALID = 6014,
    MEMBER_IS_NOT_ACTIVE = 6015,
    MEMBER_IS_FROZEN = 6016,
    MEMBER_ID_DUPLICATED = 6017,
    MEMBER_USERNAME_DUPLICATED = 6018,
    MEMBER_INTEGRATE_ID_DUPLICATED = 6019,
    MEMBER_NICKNAME_INVALID = 6020,
    MEMBER_NICKNAME_DUPLICATE = 6021,
    MEMBER_USERNAME_TOO_LONG = 6022,
    MEMBER_AT_LEAST_ONE_PHONE_EMAIL = 6023,
    MEMBER_PHONE_INVALID = 6025,
    MEMBER_PHONE_DUPLICATE = 6026,
    MEMBER_EMAIL_INVALID = 6027,
    MEMBER_EMAIL_DUPLICATE = 6028,
    MEMBER_CANNOT_ENTER_INTEGRATE = 6029,
    MEMBER_HAS_BEEN_BOUND = 6030,
    MEMBER_PHONE_EMAIL_NEITHER_MATCH = 6031,
    MEMBER_NOT_SYNCED = 6032,
    MEMBER_ALREADY_JOINED_TENANT = 6033,
    MEMBER_NOT_JOINED_TENANT = 6034,
    EMAIL_FORMAT_IS_INVALID = 6035,
    MEMBER_NICKNAME_TOO_LONG = 6036,
    MEMBER_NICKNAME_IS_EMPTY = 6037,
    MEMBER_INVITE_NO_ELIGIBLE_WITHIN_RATE_LIMIT = 6038,
    MEMBER_AVATAR_FILE_INVALID = 6039,
    MEMBER_TENANT_NOT_EXIST = 6040,
    MEMBER_NAME_UPDATE_UNSUPPORTED = 6041,
    MEMBER_DISABLE_YOURSELF_FORBIDDEN = 6042, // 60000
    MEMBER_DISABLE_OWNER_FORBIDDEN = 6043, // 60001
    MEMBER_DISABLE_SYS_MANAGER_FORBIDDEN = 6044, // 60002
    MEMBER_DISABLE_GUEST_DOCKER_FORBIDDEN = 6045, // 60003
    MEMBER_DISABLE_BEING_INVITED_FORBIDDEN = 6046, // 60007
    MEMBER_DISABLE_NOT_IN_PURCHASED_PLAN = 6047, // 60008
    MEMBER_UNIQUE_FIELD_REQUIRED = 6048, // 1084
    EXTERNAL_MEMBER_COUNT_EXCEEDED = 6050,

    /**
     * 企业集成错误.
     */
    INTEGRATE_AUTH_NOT_FOUND = 7000,
    INTEGRATE_API_RESPONSE_INVALID = 7001,
    INTEGRATE_RESOURCE_MAX_EXCEEDED = 7002,
    INTEGRATE_DEPT_INVALID = 7003,
    INTEGRATE_API_LOOP_MAX_EXCEEDED = 7004,
    INTEGRATE_DEPT_ID_REQUIRED = 7005,
    INTEGRATE_API_FREQUENCY_MAX_EXCEEDED = 7006,
    INTEGRATE_AUTH_INVALID = 7007,
    INTEGRATE_AUTO_SYNC_UNAVAILABLE = 7008,
    INTEGRATE_TENANT_AUTH_CANNOT_UNBIND = 7009,
    INTEGRATE_ID_BIND_ANOTHER_TENANT = 7011,
    INTEGRATE_PERMANENT_AUTH_CODE_OBTAIN_FAIL = 7012,
    INTEGRATE_TENANT_AUTH_INFO_OBTAIN_FAIL = 7013,
    INTEGRATE_PERSONAL_AUTH_INFO_INVALID = 7014,
    INTEGRATE_SYNCED_MEMBERS_EXCEED_MAX = 7016,
    INTEGRATE_OAUTH_AUTH_OBTAIN_USER_FAILED = 7017,
    INTEGRATE_OPERATION_NO_LARK_DENIED = 7018,
    INTEGRATE_CORPSECRET_MODE_MUST_BE_LINKED_FIRST = 7019,
    INTEGRATE_LARK_SELF_BUILT_APP_INFORMATION_INVALID = 7020,
    INTEGRATE_API_REQUEST_FAILED = 7021,
    INTEGRATE_GET_ACCESS_TOKEN_FAILED = 7022,
    INTEGRATE_WECHAT_IP_ADDRESS_WHITELIST_INVALID = 7023,
    INTEGRATE_WECHAT_ACCOUNT_AUTHORIZER_INVALID = 7024,
    INTEGRATE_CORP_ID_OR_CORP_SECRET_INVALID = 7025,
    INTEGRATE_LINK_CORP_SECRET_FAILED = 7026,
    INTEGRATE_CONVERT_CIPHER_TO_PLARIN_NOT_SUPPORTED = 7027,
    INTEGRATE_CONVERT_PLAIN_TO_CIPHER_TARGET_TENANT_EXISTS = 7028,
    INTEGRATE_PLAIN_AND_CIPHER_ASSERT_SAME_TENANT_FAILED = 7029,
    INTEGRATE_USER_BIND_TENANT_AUTH_DUPLICATE = 7030,
    INTEGRATE_CONVERT_CIPHER_TO_PLARIN_PENDING = 7031,
    INTEGRATE_USER_CANNOT_JOIN_OTHER_CORP = 7032, // 1090
    INTEGRATE_CORP_ID_NOT_FOUND = 7033,
    INTEGRATE_TENANT_AUTH_SCENARIO_DUPLICATE = 7034,
    INTEGRATE_SYNC_NOT_COMPLETED = 7035,
    INTEGRATE_SYNC_AUTH_TYPE_INVALID = 7036,
    INTEGRATE_SUITE_SCENARIO_DUPLICATE = 7037,
    INTEGRATE_JS_SDK_INJECT_FAILED = 7038, // 8032
    INTEGRATE_WXWORK_AUTH_CODE_INVALID = 7039, // 8269
    INTEGRATE_WXWORK_CORPSECRET_INVALID = 7040, // 8270
    INTEGRATE_WXWORK_IP_ADDRESS_WHITELIST_INVALID = 7041, // 8278
    // 集成模式登录相关
    INTEGRATE_DINGTALK_CP_LOGIN_ENTRY_INVALID = 7100, // 8038
    INTEGRATE_LOGIN_INFO_FETCH_FAILED = 7102, // 8027
    INTEGRATE_LOGIN_USER_NOT_WXWORK_ADMIN = 7103, // 1079
    INTEGRATE_LOGIN_USER_NOT_INTEGRATE_MEMBER = 7104, // 10012
    INTEGRATE_WXWORK_REGISTER_CODE_FETCH_FAILED = 7105, // 8209
    INTEGRATE_LARK_ISV_LOGIN_ENTRY_INVALID = 7106, // 8287
    INTEGRATE_OAUTH2_AUTHENTICATION_FAILED = 7107,
    INTEGRATE_OAUTH2_INTERACTIVE_RENDER = 7114,
    INTEGRATE_UNIFIED_AUTH_ENTRY_INVALID = 7108,
    INTEGRATE_UNIFIED_AUTH_SCENARIO_INVALID = 7109,
    INTEGRATE_UNIFIED_AUTH_FLOW_INVALID = 7110,
    INTEGRATE_UNIFIED_AUTH_HANDLER_INVALID = 7111,
    INTEGRATE_UNIFIED_AUTH_RESULT_INVALID = 7112,
    INTEGRATE_UNIFIED_AUTH_STATE_INVALID = 7113,
    // 集成模式CP授权无效
    INTEGRATE_CP_AUTH_INVALID = 7115,

    /**
     * 企业迁移错误.
     */
    CORP_MIGRATION_JOB_NOT_FOUND_OR_ACQUIRABLE = 9000,
    CORP_MIGRATION_JOB_IS_NOT_PENDING = 9001,
    CORP_MIGRATION_JOB_IS_PENDING = 9002,
    CORP_MIGRATION_JOB_IS_OUTDATED = 9003,
    CORP_MIGRATION_JOB_STAGE_INVALID = 9004,
    CORP_MIGRATION_JOB_PLAN_INVALID = 9005,
    CORP_MIGRATION_JOB_PARALLEL_NOT_ALLOWED = 9006,
    CORP_MIGRATION_JOB_NOT_RUNNABLE = 9007,
    CORP_MIGRATION_UNMIGRATED_DEPARTMENTS_EXIST = 9008,
    CORP_MIGRATION_TIMEOUT = 9009,
    CORP_MIGRATION_UNMIGRATED_MEMBERS_EXIST = 9010,
    CORP_MIGRATION_TARGET_AUTH_NOT_FOUND = 9011,

    /**
     * 第三方错误.
     */
    WX_APPID_REQUIRED = 10000, // 14000
    WX_AUTH_CONFLICT = 10001, // 14001
    WX_TMPL_INVALID_INSTALL_TYPE = 10002,
    WX_TMPL_INVALID_TYPE = 10003, // 14018
    WX_TMPL_INVALID_INSTALL_STATUS = 10004,
    WX_AUTH_INVALID = 10005, // 14000
    WX_AUTH_DISABLED = 10006, // 14007
    WX_AUTH_REFRESH_TOKEN_INVALID = 10007, // 14001
    WX_AUTH_AUTHORIZER_INVALID = 10008, // 14001
    WX_AUTH_SERVICE_TYPE_INVALID = 10009, // 14005
    WX_AUTH_VERIFY_TYPE_INVALID = 10010, // 14005
    WX_AUTH_PERM_LIST_INVALID = 10011, // 14006
    WX_SUITE_INVALID = 10012, // 14000
    WX_TMPL_INVALID_NAME = 10013, // 14017
    WX_AUTH_BIND_ANOTHER_TENANT = 10014, // 14010
    WX_AUTH_ACCOUNT_NEED_UNLINK = 10015, // 14004
    WX_RETRIEVAL_FAILED = 10016, // 14020
    WX_TMPL_INVALID_ID = 10017, // 14022
    WX_AUTH_REFRESH_TOKEN_EXPIRED = 10018, // 14025
    WX_AUTH_API_CALL_FAILED = 10019, // 14026
    WX_TMPL_OFFICIAL_INSTALL_FAILED = 10020, // 14021
    WX_TMPL_FORBIDDEN = 10021, // 14011
    WX_TMPL_EXCEED = 10022, // 14012
    WX_TMPL_CONFLICT_WITH_INDUSTRY = 10023, // 14013
    WX_TMPL_KEY_NAME_INVALID = 10024, // 14014
    WX_HISTORY_TMPL_FORBIDDEN = 10025, // 14015
    WX_TMPL_CATEGORY_NOT_MATCH = 10026, // 14024
    WX_TMPL_EXCEED_FREQUENCY_LIMIT = 10027, // 14023
    WX_AUTH_REQUIRED = 10028, // 1300
    WX_AUTH_WECHAT_ENV_MISMATCH = 10029, // 14002
    WX_AUTH_OAUTH_LINK_DUPLICATED = 10030, // 1075
    WX_AUTH_CALLBACK_MSG_INVALID = 10031, // 14003
    FANRUAN_PASSPORT_BIND_ANOTHER_ACCOUNT = 10032, // 17092
    FANRUAN_PASSPORT_BIND_CURRENT_ACCOUNT = 10033, // 17093
    BAIDU_BCE_TOKEN_OBTAIN_FAILED = 10034, // fx-code: 13004
    BAIDU_BCE_API_CALL_FAILED = 10035, // fx-code: 13005

    /**
     * 排序相关错误.
     */
    SORT_ELEM_NOT_FOUND = 11000,
    SORT_RELATIVE_ELEM_NOT_FOUND = 11001,
    SORT_PARENT_ELEM_NOT_FOUND = 11002,
    SORT_RELATIVE_ELEM_PARENT_ELEM_NOT_IN_SAME_LEVEL = 11003,

    /**
     * 单点登录错误.
     */
    // 协议不兼容.
    SSO_IDP_PROTOCOL_INCOMPATIBLE = 12000,
    // 协议未启用.
    SSO_IDP_PROTOCOL_DISABLED = 12001,
    // 配置文件不合法(未知).
    SSO_IDP_CONF_DOC_INVALID = 12002,
    // 配置文件不合法(IdP 地址).
    SSO_IDP_IN_ENDPOINT_INVALID = 12003,
    // 配置文件不合法(SLO 地址).
    SSO_IDP_OUT_ENDPOINT_INVALID = 12004,
    // 配置文件不合法(加密/签名算法).
    SSO_PAYLOAD_SIG_ALG_INVALID = 12005,
    // 配置文件不合法(秘钥/证书).
    SSO_PAYLOAD_SIG_SECRET_OR_CRT_INVALID = 12006,
    // 配置文件不合法(IdP 标识符).
    SSO_IDP_ENTITY_ID_INVALID = 12007,
    // 请求不可信.
    SSO_REQUEST_UNTRUSTED = 12008,
    // 请求协议与配置协议不一致.
    SSO_REQUEST_PROTOCOL_INCOMPATIBLE = 12009,
    // Decode 失败.
    SSO_ASSERTION_DECODE_FAILED = 12010,
    // Decode 后格式不合法.
    SSO_ASSERTION_INVALID = 12011,
    // Decode 后格式合法但二次验证失败.
    SSO_ASSERTION_VALIDATION_FAILED = 12012,
    // SSO 登录不允许切换企业
    SSO_SIGNIN_CANNOT_SWITCH_CORP = 12013,
    // 已开启单点登录屏蔽普通登录页不允许进行普通登录
    SSO_NORMAL_LOGIN_DISABLED = 12014,
    // 生成重定向单点登录认证uri过程出现错误
    SSO_AUTH_URI_GENERATION_FAILED = 12015,
    // 请联系管理员检查单点登录配置
    SSO_CONFIGURATION_INVALID = 12016, // 10013
    // 单点登录认证过程中出现错误
    SSO_AUTH_FAILED = 12017, // 10001
    // SSO 登录不允许创建企业
    SSO_SIGNIN_CANNOT_CREATE_CORP = 12018, // 100010

    /**
     * Excel 导入导出错误.
     */
    EXCEL_MEMBER_NICKNAME_DUPLICATE = 13000,
    // Excel导出成员角色关联关系数量超过限制（有单独的提示文案）.
    EXCEL_MEMBER_ROLE_REL_EXPORT_COUNT_EXCEEDED = 13001,
    EXCEL_EXPORT_FAILED = 13002,
    EXCEL_INVALID_MEMBER_IMPORT_TEMPLATE = 13003,
    EXCEL_MEMBER_IMPORT_EXCEEDS_LIMIT = 13004,
    EXCEL_IMPORT_TEMPLATE_INVALID = 13005,
    EXCEL_CORP_COOP_COMPANY_COUNT_EXCEEDED = 13006,
    EXCEL_FILE_IS_EMPTY = 13009,
    EXCEL_PARSED_FAILED = 13010,
    EXCEL_VALID_IMPORT_MEMBER_NOT_FOUND = 13011, // 4312
    EXCEL_DOWNLOAD_LINK_INVALID = 13012, // 4313
    EXCEL_MEMBER_ROLE_REL_IMPORT_LIMIT_EXCEEDED = 13013, // 4331
    EXCEL_MEMBER_ROLE_REL_IMPORT_FILE_KEY_OR_PATCH_REQUIRED = 13014, // 4332
    EXCEL_MEMBER_ROLE_REL_IMPORT_ROLE_NO_OR_LIST_REQUIRED = 13015, // 4333
    EXCEL_IMPORT_COLUMN_NOT_MATCHED = 13016,

    /**
     * 企业用量错误.
     */
    CORP_METRICS_SNAPSHOT_NOT_FOUND = 140002,

    /**
     * 套件错误.
     */
    SUITE_NOT_FOUND = 15000,
    SUITE_ID_REQUIRED = 15001,
    SUITE_ID_INVALID = 15002,
    TENANT_SUITE_CONSENT_NOT_FOUND = 15003,
    SUITE_CONSENT_PERMANENT_CODE_REQUIRED = 15004,
    SUITE_CONSENT_PERMANENT_CODE_INVALID = 15005,
    SUITE_CONSENT_STATUS_INVALID = 15006,
    SUITE_AUTHENTICATION_OUT_OF_SCOPE = 15007,
    SUITE_EVENT_DOC_VALUE_INVALID = 15008,
    SUITE_API_AUTHENTICATION_FAILED = 15009,
    SUITE_API_AUTHORIZATION_FAILED = 15010,
    SUITE_CONSENT_CORP_SCOPE_REQUIRED = 15011,
    SUITE_NOT_IN_PURCHASED_PLAN = 15012,
    SUITE_CONSENT_NOT_ACTIVATED = 15013,
    SUITE_CONSENT_CORP_SCOPE_EXCEED_LIMIT = 15014,
    SUITE_NOT_LISTEN_TO_EVENT = 15015,
    SUITE_EVENT_DOC_CLASS_INVALID = 15016,
    SUITE_EVENT_FETCH_FAILED = 15017,
    SUITE_AT_LEAST_ONE_NEEDS_TO_BE_ENABLED = 15018,
    SUITE_EXCEED_SCOPE_MEMBER_NOT_SA = 15019,
    SUITE_EXCEED_SCOPE_MEMBER_IS_SA = 15020,
    SUITE_BETA_NOT_INCLUDE_TENANT = 15021,
    SUITE_REFRESH_TOKEN_INVALID = 15022,
    SUITE_ACCESS_TOKEN_EXPIRED = 15023,
    SUITE_AUTHENTICATION_OUT_OF_SCOPE_NOT_SA = 15024,
    SUITE_AUTHENTICATION_OUT_OF_SCOPE_IS_SA = 15025,
    SUITE_CONSENT_CORP_SCOPE_MANAGED_BY_INTEGRATE_SYNC = 15026,
    // 需 consent 的租户事件误入同步推送 (fetchSuiteEvent) 路径; 这类事件应走队列/回调路径.
    SUITE_EVENT_REQUIRES_CONSENT = 15027,
    SUITE_TRIAL_PLAN_NOT_EXISTED = 15028,
    SUITE_EXCEED_SCOPE_EXTERNAL_MEMBER_NOT_SA = 15040,
    SUITE_EXCEED_SCOPE_EXTERNAL_MEMBER_IS_SA = 15041,

    /**
     * 集成模式套件错误.
     */
    // 套件相关
    INTEGRATE_SUITE_STATUS_INVALID = 16000,
    INTEGRATE_SUITE_ID_REQUIRED = 16001,
    INTEGRATE_SUITE_SECRET_REQUIRED = 16002,
    INTEGRATE_SUITE_NAME_REQUIRED = 16003,
    INTEGRATE_SUITE_TOKEN_REQUIRED = 16004,
    INTEGRATE_SUITE_ENCODING_AES_KEY_REQUIRED = 16005,
    INTEGRATE_SUITE_NOT_FOUND = 16006,
    INTEGRATE_SUITE_TYPE_INVALID = 16007,
    INTEGRATE_SUITE_WXWORK_NOT_FOUND = 16008,
    INTEGRATE_SUITE_LARK_NOT_FOUND = 16009,
    INTEGRATE_SUITE_DINGTALK_NOT_FOUND = 16010,
    INTEGRATE_SUITE_WXWORK_NEED_CONVERT = 16011,
    INTEGRATE_SUITE_DINGTALK_CARD_TEMPLATE_INVALID = 16012,
    INTEGRATE_SUITE_API_PROXY_MODE_INVALID = 16013,
    // 模式相关
    INTEGRATE_MODE_CP_AUTH_INVALID = 16100,
    INTEGRATE_TYPE_INVALID = 16101,
    // 回调相关
    INTEGRATE_LARK_CALLBACK_INVALID = 16200,
    INTEGRATE_LARK_CALLBACK_PARAM_LACK = 16201,
    INTEGRATE_DINGTALK_SYNCHTTP_FAILED = 16202,
    INTEGRATE_ORDER_RECORDED = 16203,
    INTEGRATE_WXWORK_CORPID_INVALID = 16204,
    INTEGRATE_WXWORK_CONVERT_RESULT_EMPTY = 16205,
    INTEGRATE_WXWORK_CP_APPID_REQUIRED = 16206,
    INTEGRATE_DINGTALK_LEVEL_UNSUPPORTED = 16207,
    INTEGRATE_LARK_ISV_AUTH_EXIST = 16208,
    INTEGRATE_LARK_API_PERMISSION_REQUIRED = 16209,
    INTEGRATE_ORDER_CREATE_FAIL = 16210,
    INTEGRATE_SUITE_SCENARIO_REQUIRED = 16211,
    INTEGRATE_UNBIND_PLATFROM_UNAUTH_REQUIRED = 16212,
    INTEGRATE_LARK_APPID_SECRET_LACK = 16213, // 8235
    INTEGRATE_SUITE_SCENARIO_INVALID = 16214,
    INTEGRATE_SUITE_SCENARIO_SEGMENT_INVALID = 16216,
    INTEGRATE_SUITE_SCENARIO_VARIANT_RESERVED = 16217,
    INTEGRATE_WXWORK_CORP_DIAL_PERMISSION_INVALID = 16218,
    INTEGRATE_PROVIDER_ID_DUPLICATED = 16219,
    INTEGRATE_PROVIDER_ID_NOT_FOUND = 16220,
    INTEGRATE_WXWORK_SERVICE_ORDER_NOT_FOUND = 16221,
    INTEGRATE_DINGTALK_API_CALL_FAILED = 16222,
    // 通讯录跨服务商换绑（integrate_contact_rebind）.
    INTEGRATE_CONTACT_REBIND_JOB_NOT_FOUND = 16223,
    INTEGRATE_CONTACT_REBIND_JOB_RUNNING = 16224,
    INTEGRATE_CONTACT_REBIND_JOB_NOT_FULFILLED = 16225,
    INTEGRATE_CONTACT_REBIND_JSY_ACK_PENDING = 16226,
    INTEGRATE_CONTACT_REBIND_MAPPINGS_UPLOAD_NOT_ALLOWED = 16227,
    INTEGRATE_CONTACT_REBIND_MAPPING_OUT_OF_RANGE = 16228,
    INTEGRATE_CONTACT_REBIND_SOURCE_TENANT_NOT_JSY_MIGRATION = 16229,
    INTEGRATE_CONTACT_REBIND_SOURCE_TARGET_SAME = 16230,
    INTEGRATE_CONTACT_REBIND_DINGTALK_NOT_SUPPORTED = 16231,
    INTEGRATE_CONTACT_REBIND_UNMAPPED_ENTITY = 16232,
    INTEGRATE_CONTACT_REBIND_PROVIDER_NOT_SUPPORTED = 16233,
    INTEGRATE_CONTACT_REBIND_PROVIDER_MISMATCH = 16234,

    SEND_MESSAGE_FAILED = 17000,
    MESSAGE_CONNECTOR_INVALID = 17001,
    SEND_SMS_MESSAGE_FAILED = 17002,
    SMS_TEMPLATE_CODE_INVALID = 17003,
    SMS_SERVICE_DISABLED = 17004,
    COIN_CONSUMPTION_DISABLED = 17005,
    INSUFFICIENT_COIN_BALANCE = 17006,
    EMAIL_SERVICE_DISABLED = 17007,
    SEND_EMAIL_MESSAGE_FAILED = 17008,
    WX_TEMPLATE_KEYWORD_INVALID = 17009, // 14019
    APP_PUSH_PLATFORM_INVALID = 17010,
    APP_PUSH_TOKEN_INVALID = 17011,
    APP_PUSH_TOKEN_UPDATE_AT_INVALID = 17012,
    APP_PUSH_LIMIT_EXCEED = 17013,
    TEST_EMAIL_SEND_LIMIT_EXCEEDED = 17014,
    MAIL_QUOTA_EXCEEDED = 17015,
    APP_OAUTH_WECHAT_NOT_ENABLED = 17016,
    APP_OAUTH_GOOGLE_NOT_ENABLED = 17017,
    SMS_SIGN_NAME_NOT_FOUND = 17018,

    /**
     * 鉴权错误
     */
    AUTH_LOCK_COUNT_INVALID = 18000,
    AUTH_LOCK_ID_REQUIRED = 18001,
    AUTH_LOCK_TYPE_INVALIDATE = 18002,

    /**
     * 套餐错误.
     */
    PLAN_LEVEL_INVALID = 19003,
    PLAN_DATE_INVALID = 19004,
    SUITE_PLAN_ID_INVALID = 19005,
    SEAT_COUNT_EXCEEDED = 19006,
    PLAN_TRIAL_COUNT_LIMIT_EXCEEDED = 19007,
    PAID_PLAN_CANNOT_START_TRIAL = 19008,
    PLAN_FEATURE_KEY_INVALID = 19009,
    TENANT_PLAN_NOT_FOUND = 19010,
    PLAN_USERS_INVALID = 19011,
    SA_ONLY_PAID_CAN_MODIFY_PLAN_EXPIRE = 19012,
    SA_ONLY_TRAIL_CAN_MODIFY_PLAN_EXPIRE = 19013,
    SA_ONLY_PAID_OR_TRIAL_CAN_MODIFY_USERS = 19014,
    SA_ADDON_ITEM_INVALID = 19015,
    SA_FREE_PLAN_CANNOT_MODIFY_ADDON = 19016,
    SA_PAID_UNLIMITED_PLAN_CANNOT_MODIFY_USERS = 19017,

    /**
     * 互联组织错误.
     */
    TENANT_PERMISSION_DENIED_MANAGE_TARGET_TENANT = 20000,
    TENANT_NO_CONNECTION_TO_TARGET_TENANT = 20001,
    CORP_COOP_NOT_IN_PLAN = 20002,
    CORP_COOP_EXCEEDED = 20003,
    CORP_COOP_PUBLIC_LINK_AT_LEAST_ONE = 20004,
    CORP_COOP_INVITATION_SEND_EXCEEDED = 20005,
    CORP_COOP_PUBLIC_LINK_NOT_FOUND = 20006,
    CORP_COOP_PUBLIC_LINK_EXCEEDED = 20007,
    CORP_COOP_MEMBER_COUNT_EXCEEDED = 20008,
    CORP_COOP_APPLY_TMP_OWNER_FLOW_CONTROL_EXCEEDED = 20009,
    CORP_COOP_GUEST_HAS_TMP_OWNER = 20010,
    CORP_COOP_GLOBAL_DOCKER_COUNT_EXCEEDED = 20011,
    CORP_COOP_CONTACT_PERSON_COUNT_EXCEEDED_FREE_PLAN = 20012,
    CORP_COOP_CONTACT_PERSON_COUNT_EXCEEDED_PAID_PLAN = 20013,
    CORP_COOP_CANNOT_REMOVE_GLOBAL_DOCKER = 20014,
    CORP_COOP_CANNOT_SET_MEMBER_AS_DOCKER = 20015,
    CORP_COOP_CORP_NAME_DUPLICATED = 20016,
    CORP_COOP_SELF_ALREADY_DOCKER = 20017,
    CORP_COOP_MEMBER_DUPLICATED_AS_DOCKER = 20018,
    CORP_COOP_INVALID_PARAMETER = 20019,
    CORP_COOP_DOCKER_HAS_RESIGNED = 20020,
    INACTIVE_COMPANY_OWNER_REMOVAL_PROHIBITED = 20021,
    CORP_COOP_INVITE_LINK_EXPIRED = 20022,
    CORP_COOP_INVITE_OWNER_ALREADY_HAS_TENANT = 20023,
    CORP_COOP_CANNOT_INTERCONNECT_WITH_SELF = 20024,
    CORP_COOP_ALREADY_INTERCONNECTED = 20025,
    CORP_COOP_IMPORT_MOBILE_NUMBER_MISMATCH = 20026,
    CORP_COOP_INVALID_COMPANY_CASCADING_FAILURE = 20027,
    CORP_COOP_IMPORT_COMPANY_NAME_REQUIRED = 20028,
    CORP_COOP_IMPORT_BUSINESS_OWNER_REQUIRED = 20029,
    CORP_COOP_IMPORT_DUPLICATE_OWNER_MOBILE_DUPLICATE = 20030,
    CORP_COOP_IMPORT_ONLY_ONE_OWNER_ALLOWED = 20031,
    CORP_COOP_IMPORT_MOBILE_NUMBER_REQUIRED = 20032,
    CORP_COOP_IMPORT_OWNER_NOT_SPECIFIED = 20033,
    CORP_COOP_IMPORT_OWNER_ALREADY_HAS_COMPANY = 20034,
    CORP_COOP_IMPORT_NO_CONTACT_PERSONS = 20035,
    CORP_COOP_IMPORT_COMPANY_FAILED = 20036,
    CORP_COOP_CREATE_TENANT_CONFIRMED = 20037,
    CORP_COOP_IMPORT_PHONE_NOT_BELONG_TO_OWNER = 20038, // 19043
    /**
     * 微信相关错误.
     */
    WECHAT_SCENE_INVALID = 21001,
    WECHAT_SCENE_QRCODE_TICKET_INVALID = 21002,

    /**
     * 第三方 API 相关
     */
    API_PERMISSION_DENIED = 22000,

    /**
     * 文件相关.
     */
    FILE_OBTAIN_FAILED = 23000, // fx-code: 4517
    FILE_MANAGE_FILE_STORAGE_STAT_RUNNING = 23001, // fx-code: 4528
    FILE_MANAGE_FILE_STORAGE_STAT_REFRESH_TOO_FREQUENT = 23002, // fx-code: 4535
    FILE_MANAGE_FILE_STORAGE_STAT_NOT_COMPLETED = 23003, // fx-code: 4539
    FILE_CREATE_FAILED = 23004, // fx-code: 4507
    FILE_UPLOAD_CALLBACK_AUTH_INVALID = 23005, // fx-code: 4508
    FILE_UPLOAD_SIZE_EXCEEDED = 23006, // fx-code: 7208

    /**
     * Webhook.
     */
    RESERVED_IP_FORBIDDEN = 22001,
    RESPONSE_SIZE_EXCEED_LIMIT = 22002,
    REQUEST_CONFIG_INVALID = 22003,
    WEBHOOK_UNAVAILABLE = 22004,
    WEBHOOK_URL_INVALID = 22005,
    WEBHOOK_UPDATE_FAILED = 22006,

    /**
     * 访问外部服务相关报错
     */
    CONNECTOR_ORDER_SERVER_UNABLE = 24000,
    CONNECTOR_ORDER_SERVER_CALL_FAIL = 24001,
    CONNECTOR_DATA_CENTER_UNABLE = 24002,
    CONNECTOR_DATA_CENTER_CALL_FAIL = 24003,
    CONNECTOR_LOG_STATS_SERVER_UNABLE = 24004, // fx-code: 45000
    CONNECTOR_LOG_STATS_SERVER_CALL_FAIL = 24005, // fx-code: 45001
    CONNECTOR_JIUSHUYUN_CALL_FAIL = 24006,
    CONNECTOR_TEMPLATE_SERVICE_UNABLE = 24007, // fx-code: 44001
    CONNECTOR_TEMPLATE_SERVICE_CALL_FAIL = 24008, // fx-code: 44000
    TEMPLATE_RESOURCE_LOCKED = 24009, // fx-code: 44005

    /**
     * 独享版
     */
    SELF_HOSTED_NOT_INVITE_REGISTER_DENIED = 25000,
    SELF_HOSTED_NOT_ALLOW_CORP_CREATE = 25001, // 36001

    /**
     * 消息
     */
    MESSAGE_DEVICE_ID_INVALID = 26000,
    MESSAGE_RECEIVER_AT_LEAST_ONE_PHONE_EMAIL = 26001,
    MESSAGE_RECEIVER_MAX_SIZE_EXCEEDED = 26002,
    MESSAGE_RECEIVER_VERIFICATION_MINUTE_LIMIT_EXCEEDED = 26003,
    MESSAGE_RECEIVER_VERIFICATION_DAY_LIMIT_EXCEEDED = 26004,
    MESSAGE_RECEIVER_ALREADY_VERIFIED = 26005,
    MESSAGE_RECEIVER_NOT_FOUND = 26006,
    MESSAGE_RECEIVER_TOKEN_INVALID = 26007,
    MESSAGE_SHORT_LINK_QUERY_TOO_MANY_REQUESTS = 26008,

    /**
     * OIDC 服务相关报错.
     */
    OIDC_CLIENT_NOT_FOUND = 27000,
    OIDC_REDIRECT_URI_INVALID = 27001,
    OIDC_SCOPE_INVALID = 27002,
    OIDC_AUTHORIZATION_CODE_INVALID = 27003,

    /**
     * 云币
     */
    USER_COIN_CONF_IMMUTABLE = 28000,
    COIN_CONSUME_MODE_INVALID = 28001,
    COIN_CONSUME_REQUEST_INVALID = 28002,
    COIN_CONSUME_TRANSACTION_CONFLICT = 28003,
    COIN_CONSUME_ACCEPT_FAILED = 28004,

    /**
     * 开放平台
     */
    OPEN_PLATFORM_API_KEYS_MAX_REACHED = 29000,
    OPEN_PLATFORM_API_KEY_NOT_EXIST = 29001,
    OPEN_PLATFORM_TRIGGER_CONDITION_UNSUPPORTED = 29002,
    OPEN_PLATFORM_CALL_FAILED = 29003,
    OPEN_PLATFORM_PLUGIN_TRIGGER_FAILED = 29004,
    OPEN_PLATFORM_PLUGIN_EXECUTE_FAILED = 29005,
    OPEN_PLATFORM_AUTOMATIONS_CALLBACK_INVALID = 29006,
    OPEN_PLATFORM_UNAVAILABLE = 29007,
    OPEN_PLATFORM_PLUGIN_UNINSTALLED = 29008,
    OPEN_PLATFORM_PLUGIN_DISABLED = 29009,
    OPEN_PLATFORM_API_FEATURE_UNAVAILABLE = 29010,
    OPEN_PLATFORM_SUITE_NOT_REGISTERED = 29011,
    OPEN_PLATFORM_SUITE_ID_KEY_INVALID = 29012,
    OPEN_PLATFORM_INVALID_CODE = 29013,
    OPEN_PLATFORM_SUITE_ALREADY_AUTHORIZED = 29014,
    OPEN_PLATFORM_OAUTH_AUTH_FREQUENT = 29015,
    OPEN_PLATFORM_INVALID_PARAMETERS = 29016,
    OPEN_PLATFORM_INVALID_API_KEY = 29017,
    OPEN_PLATFORM_PLUGIN_CONFIG_NOT_EXIST = 29018,
    OPEN_PLATFORM_PLUGIN_PARAM_INVALID = 29019,
    OPEN_PLATFORM_PLUGIN_CUSTOM_ERROR = 29020,
    OPEN_PLATFORM_CUSTOM_PLUGIN_UNAVAILABLE = 29021,
    OPEN_PLATFORM_BATCH_UPDATE_LIMIT_EXCEEDED = 29022,
    OPEN_PLATFORM_BATCH_CREATE_LIMIT_EXCEEDED = 29023,
    OPEN_PLATFORM_TRANSACTION_ID_INVALID = 29024,
    OPEN_PLATFORM_TRANSACTION_ID_DUPLICATE = 29025,
    OPEN_PLATFORM_API_FILE_UPLOAD_FAILED = 29026,
    OPEN_PLATFORM_FORM_DATA_QUERY_UNSUPPORTED = 29027,
    OPEN_PLATFORM_PLUGIN_DEBUG_FREQUENT = 29028,
    OPEN_PLATFORM_FORM_NAME_REQUIRED = 29029,
    OPEN_PLATFORM_FIELD_TYPE_REQUIRED = 29030,
    OPEN_PLATFORM_FIELD_TYPE_UNSUPPORTED = 29031,
    OPEN_PLATFORM_BATCH_DELETE_LIMIT_EXCEEDED = 29032,
    OPEN_PLATFORM_SUB_FIELD_TYPE_UNSUPPORTED = 29033,
    OPEN_PLATFORM_CLOUD_COIN_INSUFFICIENT = 29034,
    OPEN_PLATFORM_CLOUD_COIN_PAYMENT_DISABLED = 29035,
    OPEN_PLATFORM_ACCOUNT_NOT_EXIST = 29036,
    OPEN_PLATFORM_ACCOUNT_INFO_INCORRECT = 29037,
    OPEN_PLATFORM_CODE_LENGTH_EXCEEDED = 29038,
    OPEN_PLATFORM_PLUGIN_CODE_CORRECTION_REQUIRED = 29039,
    OPEN_PLATFORM_GMAIL_UNVERIFIED = 29040, // 17041
    OPEN_PLATFORM_EMAIL_ACCOUNT_EXISTS = 29041, // 17042
    OPEN_PLATFORM_FRONTEND_EVENT_CONFIG_INCOMPLETE = 29042,
    OPEN_PLATFORM_GOOGLE_ACCOUNT_LINK_FAILED = 29043, // 17044
    OPEN_PLATFORM_APPLE_ACCOUNT_LINK_FAILED = 29044, // 17045
    OPEN_PLATFORM_PLUGIN_EXPIRED = 29045,
    OPEN_PLATFORM_PLUGIN_TRIGGER_FREQUENT = 29046,
    OPEN_PLATFORM_PLUGIN_NODE_CONFIG_ERROR = 29047,
    OPEN_PLATFORM_NETWORK_ERROR = 29048,
    OPEN_PLATFORM_PLUGIN_NODE_BACKEND_ONLY = 29049,
    OPEN_PLATFORM_IP_WHITELIST_REJECTED = 29050,
    OPEN_PLATFORM_APP_AUTHORIZATION_REJECTED = 29051,
    OPEN_PLATFORM_API_AUTHORIZATION_REJECTED = 29052,
    OPEN_PLATFORM_PLUGIN_FUNCTION_NOT_EXIST = 29053,
    OPEN_PLATFORM_INPUT_MEMBER_DEPT_ROLE_EXCEEDED = 29054,
    OPEN_PLATFORM_RUNTIME_CALL_METHOD_ILLEGAL = 29055,
    OPEN_PLATFORM_SUITE_NOT_AUTHORIZED = 29056,
    OPEN_PLATFORM_SUITE_CORP_SCOPE_REQUIRED = 29057,
    OPEN_PLATFORM_SUITE_OUT_OF_SCOPE_NON_ADMIN = 29058,
    OPEN_PLATFORM_SUITE_DATA_ANALYSIS_UNAVAILABLE = 29059,
    OPEN_PLATFORM_SUITE_OUT_OF_SCOPE_ADMIN = 29060,
    OPEN_PLATFORM_SUITE_EXCEED_SCOPE_NON_ADMIN = 29061,
    OPEN_PLATFORM_SUITE_EXCEED_SCOPE_ADMIN = 29062,
    OPEN_PLATFORM_SUITE_EVENT_NOT_LISTENED = 29063,
    OPEN_PLATFORM_SUITE_DOC_CLASS_INVALID = 29064,
    OPEN_PLATFORM_SUITE_EVENT_FETCH_FAILED = 29065,
    OPEN_PLATFORM_SUITE_BETA_TENANT_REJECTED = 29066,
    OPEN_PLATFORM_PLUGIN_TRIGGER_RUNTIME_DEPRECATED = 29067,
    OPEN_PLATFORM_SERVICE_PROVIDER_WITHDRAWAL_AMOUNT_ILLEGAL = 29068,
    OPEN_PLATFORM_SERVICE_PROVIDER_WITHDRAWAL_ORDER_ID_ILLEGAL = 29069,
    OPEN_PLATFORM_PLUGIN_TRIAL_UNAVAILABLE = 29070,
    OPEN_PLATFORM_PLUGIN_TRIAL_EXPIRED = 29071,
    OPEN_PLATFORM_BATCH_HARD_DELETE_API_UNSUPPORTED = 29072,
    OPEN_PLATFORM_OAUTH2_TOKEN_REFRESH_FAILED = 29073,
    OPEN_PLATFORM_OAUTH2_AUTHORIZATION_EXPIRED = 29074,
    OPEN_PLATFORM_OAUTH2_CONFIG_ABNORMAL = 29075,
    OPEN_PLATFORM_OAUTH2_TOKEN_PATH_ABNORMAL = 29076,
    OPEN_PLATFORM_OAUTH2_TOKEN_FORMAT_ABNORMAL = 29077,
    OPEN_PLATFORM_OAUTH2_TOKEN_EXPIRATION_PATH_ABNORMAL = 29078,
    OPEN_PLATFORM_OAUTH2_TOKEN_EXPIRATION_TIME_ABNORMAL = 29079,
    OPEN_PLATFORM_OAUTH2_REFRESH_TOKEN_PATH_ABNORMAL = 29080,
    OPEN_PLATFORM_OAUTH2_REFRESH_TOKEN_ABNORMAL = 29081,
    OPEN_PLATFORM_OAUTH2_REFRESH_TOKEN_EXPIRATION_PATH_ABNORMAL = 29082,
    OPEN_PLATFORM_OAUTH2_REFRESH_TOKEN_EXPIRATION_TIME_ABNORMAL = 29083,
    OPEN_PLATFORM_TENANT_NO_ACTIVE_SUITE = 29084,
    OPEN_PLATFORM_TENANT_TRIAL_LIMIT_REACHED = 29085,
    OPEN_PLATFORM_TENANT_PAID_PLAN_IN_SUITE = 29086,
    OPEN_PLATFORM_SUITE_AT_LEAST_ONE_ENABLE = 29087,
    OPEN_PLATFORM_FANRUAN_PASSPORT_BOUND_TO_OTHER = 29088,
    OPEN_PLATFORM_ACCOUNT_ALREADY_BOUND = 29089,
    OPEN_PLATFORM_FANRUAN_PASSPORT_UNBOUND_PHONE_LOGIN_REQUIRED = 29090, // 17094
    OPEN_PLATFORM_FANRUAN_PASSPORT_UNBOUND_EMAIL_LOGIN_REQUIRED = 29091, // 17095
    OPEN_PLATFORM_NOT_CANARY = 29092, // 17139

    /**
     * 开放平台集成应用（自建产品）相关错误.
     * 内部 ECode 用 29093 起连续，bizCode 映射现网数字（17100-17110 / 17014 / 17016 / 17017 / 17098 / 17099 / 3005 / 1058 / 1010 / 1098 / 17002 / 17018 / 8302）.
     * 禁止复用已占用的 17014(TEST_EMAIL_SEND_LIMIT_EXCEEDED) / 17016(APP_OAUTH_WECHAT_NOT_ENABLED) / 17017(APP_OAUTH_GOOGLE_NOT_ENABLED) / 17018(SMS_SIGN_NAME_NOT_FOUND) 号段.
     */
    OPEN_APPLICATION_NOT_FOUND = 29115, // 17100 应用不存在 / 未启用
    OPEN_APPLICATION_COUNT_EXCEEDED = 29093, // 17101 超过 50
    OPEN_APPLICATION_DOMAIN_INVALID = 29094, // 17102 白名单非法域名
    OPEN_APPLICATION_REDIRECT_HOST_NOT_ALLOWED = 29095, // 17103 跳转 URL hostname 不在白名单
    OPEN_APPLICATION_HOME_HOST_NOT_ALLOWED = 29096, // 17104 首页域名
    OPEN_APPLICATION_MANAGEMENT_HOST_NOT_ALLOWED = 29097, // 17105 管理页域名
    OPEN_APPLICATION_REFERER_HOST_NOT_ALLOWED = 29098, // 17106 referer
    OPEN_APPLICATION_WHITELIST_REQUIRED_WHEN_UPDATE_URL = 29099, // 17107 改 URL 未带白名单
    OPEN_APPLICATION_NOT_ENABLED = 29100, // 17108 预留（现网路径未用，定义以免以后误用 17100）
    OPEN_APPLICATION_FEATURE_UNAVAILABLE = 29101, // 17109 套餐无功能点
    OPEN_APPLICATION_WHITELIST_LENGTH_EXCEEDED = 29102, // 17110 白名单 > 5
    OPEN_APPLICATION_PARAM_INVALID = 29103, // 3005 缺 name/desc/app_id/url_type 等
    OPEN_APPLICATION_PERMISSION_DENIED = 29104, // 1058 无开放平台管理权 / 无 operator
    OPEN_APPLICATION_OAUTH_CODE_INVALID = 29105, // 17014 code 无效
    OPEN_APPLICATION_OAUTH_PARAM_INVALID = 29106, // 17017 OAuth 参数 / 未支持的 scope
    OPEN_APPLICATION_REDIRECT_URL_NOT_ALLOWED = 29107, // 17098 redirect_uri 不在 URI 白名单
    OPEN_APPLICATION_SECRET_APP_MISMATCH = 29108, // 17099 secret 与 code 的 app 不一致
    OPEN_APPLICATION_OAUTH_RATE_LIMITED = 29109, // 17016 发码超频
    OPEN_APPLICATION_USER_NOT_FOUND = 29110, // 1010 兑换时用户不存在
    OPEN_APPLICATION_MEMBER_NOT_FOUND = 29111, // 1098 兑换时无内部成员
    OPEN_APPLICATION_API_KEY_NOT_FOUND = 29112, // 17002 关联 key 丢失
    OPEN_APPLICATION_SECRET_INVALID = 29113, // 17018 Bearer secret 不存在 / 禁用 / 类型不是 suite
    OPEN_APPLICATION_PLAN_API_UNAVAILABLE = 29114, // 8302 套餐既无 OpenAPI 也无 OpenApplication

    /**
     * 数据同步
     */
    DATA_SYNC_SERVICE_CALL_FAILED = 30000,
    DATA_SYNC_TASK_CREATE_FAILED = 30001,
    DATA_SYNC_TASK_EXECUTE_FAILED = 30002,
    SYNC_TASK_TIMEOUT = 30003,
    SYNC_TASK_DATA_EXCEEDED = 30004,
    DATA_SOURCE_NOT_FOUND = 30005,
    DATA_SOURCE_SUBSCRIPTION_PLAN_NOT_EXIST = 30006,
    DATA_SOURCE_SUBSCRIPTION_PLAN_DAY_INVALID = 30007,
    DATA_SOURCE_DUPLICATE = 30008,
    DATA_SOURCE_PIPELINE_NOT_FOUND = 30009,
    DATA_SOURCE_TABLE_NOT_FOUND = 30010,
    DATA_SOURCE_JOB_NOT_FOUND = 30011,
    DATA_SOURCE_JOB_STATUS_NOT_ABORTABLE = 30012,
    DATA_SOURCE_JOB_OPERATOR_INVALID = 30013,
    DATA_SOURCE_JOB_STATUS_NOT_TERMINAL = 30014,
    DATA_SOURCE_CREDENTIALS_NOT_FOUND = 30015,
    DATA_SOURCE_SUBSCRIPTION_NOT_FOUND = 30016,
    DATA_SOURCE_SUBSCRIPTION_EXPIRED = 30017,
    DATA_SOURCE_NOT_RELEASED = 30018,

    /**
     * 订单相关错误.
     */
    ORDER_TYPE_NOT_SUPPORTED = 31000,
    ORDER_NOT_FOUND = 31001,
    ORDER_DELETE_FAILED = 31002,
    ORDER_IS_RECEIPTED_ADVANCE = 31003,
    ORDER_IS_UNABLE_TO_PAY = 31004,
    ORDER_IS_NOT_ENABLED_FOR_SELFHOSTED = 31005,
    ORDER_PLAN_IS_NOT_ACTIVATE = 31006,
    ORDER_ISV_CANNOT_RENEW_ADDON = 31007,
    ORDER_PURCHASE_TYPE_INVALID = 31008,
    ORDER_GOODS_HAS_BEEN_OBSOLETED = 31009,

    /**
     * 导入免审
     */
    DIRECT_USER_IMPORT_STRATEGY_NOT_FOUND = 32000, // 120000
    DIRECT_USER_IMPORT_RELATED_USER_NOT_FOUND = 32001, // 120001

    /**
     * 工作交接
     */
    HANDOVER_TASK_IS_RUNNING = 33000,
    HANDOVER_MEMBER_NOT_IN_ROLE = 33001, // 成员已不在该角色

    /**
     * OCR 相关错误.
     */
    OCR_RECOGNITION_FAILED = 34000, // fx-code: 16004
    OCR_TARGET_NOT_FOUND = 34001, // fx-code: 16005

    /**
     * 成员系统表字段.
     */
    MEMBER_FIELD_VALUE_TYPE_INVALID = 35000, // 字段值类型不合法.
    MEMBER_FIELD_VALUE_REQUIRED = 35001, // 必填字段不允许为空/清空.
    MEMBER_FIELD_VALUE_OPTION_INVALID = 35002, // 字段值不在枚举选项内.
    MEMBER_FIELD_WIDGET_TYPE_UNSUPPORTED = 35003, // 未支持的控件类型.
    MEMBER_FIELD_WIDGET_NAME_RESERVED = 35004, // 字段标识与 member_datas 固定保留列冲突.
    MEMBER_FIELD_WIDGET_NAME_DUPLICATED = 35005, // 字段标识在字段定义集合内重复.
    MEMBER_FIELD_SOURCE_UNSUPPORTED = 35006, // 未知字段来源, 写入路由拒绝(禁止静默落库).
    MEMBER_FIELD_NOT_WRITABLE = 35007, // 字段不可经成员字段写入口修改(如手机/邮箱权威在账号域).
    MEMBER_FIELD_NOT_FOUND = 35008, // 字段不存在或未定义.
    MEMBER_FIELD_BATCH_UPDATE_FORBIDDEN = 35009, // 字段不允许批量修改(编号/手机/邮箱或已停用字段).
    MEMBER_BATCH_UPDATE_LIMIT_EXCEEDED = 35010, // 批量修改目标成员数超上限.
    MEMBER_BATCH_TASK_NOT_FOUND = 35011, // 批量修改任务不存在或不可见.
    MEMBER_BATCH_UPDATE_TARGET_INVALID = 35012, // 批量修改目标条件非法(成员列表与部门至少一项).
    MEMBER_BATCH_KEY_EXPIRED = 35013, // 批次队列过期或不存在(引导重新 count).
    MEMBER_BATCH_TASK_DUPLICATED = 35014, // 同一批次重复创建任务.
    MEMBER_BATCH_TASK_RUNNING = 35015, // 同企业已有批量任务运行中(企业锁冲突).
    MEMBER_FIELD_DISPLAY_CONFIG_INVALID = 35016, // 展示配置非法(场景键不支持或可见集越界).
    MEMBER_FIELD_VALUE_TEXT_TOO_LONG = 35017, // 扩展文本字段值超长(导入校验).
    MEMBER_FIELD_VALUE_DATE_FORMAT_INVALID = 35018, // 日期字段文本无法解析为有效日期(导入校验).
    // 35019/35020(拒重/频控)已随同步状态机迁至简道云侧本源定义, 号位空缺不复用.
    MEMBER_SYNC_CDC_CALL_FAILED = 35021, // 调用 CDC 同步服务失败(登记).
    MEMBER_SYNC_ACTIVATION_PREPARE_FAILED = 35022, // 开通前置处理失败(字段建档/钩子重投影), 调用方按本次动作未发生处理.
    CORP_RESOURCE_SYNC_DISABLED = 35023, // 通讯录资源同步能力未在本部署启用(部署级总闸关闭).
    MEMBER_FIELD_VALUE_REFERENCE_NOT_FOUND = 35024,
    MEMBER_FIELD_NOT_MANAGEABLE = 35027,
    MEMBER_FIELD_NAME_DUPLICATED = 35028,
    MEMBER_FIELD_CUSTOM_LIMIT_EXCEEDED = 35029,
    MEMBER_FIELD_OPTIONS_INVALID = 35030,
    MEMBER_FIELD_SORT_INVALID = 35031,
    MEMBER_FIELD_VALUE_DUPLICATE = 35032,
    MEMBER_FIELD_NO_REPEAT_NOT_ALLOWED = 35033
}

/**
 * 后台最终返回的错误码格式：带有前缀 'P#'
 */
export const ECode = new Proxy(RawECode, {
    get(target, prop: keyof typeof RawECode) {
        if (prop in target) {
            return `P#${target[prop]}`;
        }
        return undefined;
    }
}) as unknown as { [K in keyof typeof RawECode]: string };

export default ECode;
